import type { DataBindingComponentModel } from '@wix/data-binding-registry-sdk'
import { FieldType } from '@wix/wix-data-schema-types'

export const dashboardInfoIcon: DataBindingComponentModel = {
  panel: {
    height: 576,
    title: 'dsgnsys_DashboardInfoIcon_dataBinding_panelTitle',
    helpId: '2e50a66a-a200-4639-880b-dd7c2589246a',
  },
  isConnectGfppEnabled: true,
  sections: [
    {
      role: 'DashboardInfoIconRole',
      bindings: [
        {
          title: 'dsgnsys_DashboardInfoIcon_dataBinding_tooltip_label',
          prop: 'tooltip',
          supportedFieldTypes: [FieldType.text, FieldType.richText],
          defaultFieldType: FieldType.text,
        },
        {
          title: 'dsgnsys_DashboardInfoIcon_dataBinding_tooltipLinkText_label',
          prop: 'tooltipLinkText',
          supportedFieldTypes: [FieldType.text, FieldType.richText],
          defaultFieldType: FieldType.text,
        },
        {
          title: 'dsgnsys_DashboardInfoIcon_dataBinding_tooltipLink_label',
          prop: 'tooltipLink',
          supportedFieldTypes: [FieldType.url],
          defaultFieldType: FieldType.url,
        },
      ],
    },
  ],
  compactErrorPanel: true,
}
